const INVALID_CREDENTIALS_MESSAGE = 'Identifier or password invalid.';

export default INVALID_CREDENTIALS_MESSAGE;
